import { InjectionToken } from '@angular/core';
import { IEnvironmentSettings, IFeatureSettings, IGlobalSettings, TFeature } from '../model';

export const FEATURE_NAME = new InjectionToken<TFeature>('FEATURE_NAME');
export const FEATURE_SETTINGS = new InjectionToken<IFeatureSettings>('FEATURE_SETTINGS');

export const provideFeatureName = (featureName: TFeature) => {
  return [
    {
      provide: FEATURE_NAME,
      useValue: featureName
    }
  ];
};

export const provideFeatureSettings = (featureSettings: IFeatureSettings) => {
  return [
    {
      provide: FEATURE_SETTINGS,
      useValue: featureSettings
    }
  ];
};

export const GLOBAL_SETTINGS = new InjectionToken<IGlobalSettings>('GLOBAL_SETTINGS');
export const ENV_SETTINGS = new InjectionToken<IEnvironmentSettings>('ENV_SETTINGS');

export const provideShellSettings = (shellSettings: IGlobalSettings) => {
  return [
    {
      provide: GLOBAL_SETTINGS,
      useValue: shellSettings
    }
  ];
};
